/**
 * Gets the message to be displayed when a user doesn't have an id card
 * because they have a comp only policy
 */
function getCompOnlyMessage(policyName, compOnlyType) {
    return compOnlyType === 'EXCESS_TPL'
        ? 'In your province, your government insurance provides primary liability coverage for your vehicle(s). Please contact your local broker for your government insurance to obtain proof of primary liability insurance (i.e., “pink cards”).'
        : "You only have Comprehensive coverage for your ".concat(policyName, " policy. This doesn't cover damages while on the road, so an ID card isn't issued.");
}

export { getCompOnlyMessage };
